module.exports = __webpack_public_path__ + "img/hr-V-R-5-unload-connect.679ee0fd.png";